export const APP_STORE_URL =
  'https://apps.apple.com/us/app/exos-fit/id1570526785';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.teamexos.exosfit';

// Public landing path printed in the sign-up QR code; redirects to the store for the scanning device.
export const DOWNLOAD_APP_PATH = '/download';
export const DOWNLOAD_APP_URL = `https://fit.teamexos.com${DOWNLOAD_APP_PATH}`;

export const PHONE_USER_AGENT_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export type MobilePlatform = 'ios' | 'android';

export const getMobilePlatform = (
  userAgent: string,
): MobilePlatform | undefined => {
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'ios';
  }
  if (/Android/i.test(userAgent)) {
    return 'android';
  }
  return undefined;
};

export const getAppStoreUrl = (userAgent: string): string | undefined => {
  switch (getMobilePlatform(userAgent)) {
    case 'ios':
      return APP_STORE_URL;
    case 'android':
      return PLAY_STORE_URL;
    default:
      return undefined;
  }
};
